export default __webpack_public_path__ + "static/media/rail-replacement-bus.b876ad0c.png";